import * as React from "react";

function VCBase(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.982 6.91L10.251.135c-.173-.172-.37-.186-.543-.014L0 6.91v11.998c0 .73.551 1.05 1.288 1.05h3.929a.433.433 0 00.434-.43v-5.98h8.712v6.021c0 .236.195.433.435.433h3.827c.736 0 1.354-.604 1.354-1.312 0 0 .044-9.397.003-11.78z"
        fill="#265BFF"
      />
      <path
        d="M18.506 17.998c0 .39-.367.547-.82.547h-1.91v-5.768c-.088-.451-.744-.604-.961-.604H5.188c-.274-.017-.84.229-.93.637v5.734h-1.94c-.47 0-.803-.337-.803-.546V7.693c.075-.117 8.496-5.704 8.496-5.704l8.496 5.704-.001 10.305z"
        fill="#fff"
      />
    </svg>
  );
}

export default VCBase;